export const EMAIL_REGEX =
  /^(?=.{1,320}$)[\w.%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

export const PHONE_REGEX = /^(\+?\d{1,3})?\d{10}$/;
